import { Button } from 'flowbite-react';
import React from 'react';
import { Img } from 'react-image';
import { Link, useNavigate } from 'react-router-dom';

type Props = {
	customStyleClass?: string;
};

const SuccessPage = ({ customStyleClass }: Props) => {
	const navigate = useNavigate();
	return (
		<div
			className={`flex items-center flex-col gap-2 justify-center dark:bg-[#111E2C] w-full min-h-[calc(100vh-72px)] ${
				customStyleClass ? customStyleClass : ''
			} `}
		>
			<div>
				<Img src={'/assets/greenCheck.svg'} width={64} height={64} />
			</div>
			<div className="text-center flex flex-col gap-1 mt-8 p-3 text-[#28293D] dark:text-white">
				<p>Thank you! Your job position details are recorded.</p>
				<p>We'll alert you when it's live, and you can view candidate recommendations.</p>

				<Link
					className="text-[#7777E7] underline mt-2"
					to="https://calendly.com/recruiters-levelup/onboarding-session"
					target="_blank"
				>
					Book a support call
				</Link>

				<div className="flex items-center justify-center mt-3">
					<Button
						color="purplePlaced"
						onClick={() => {
							navigate('/positions');
						}}
					>
						Got It
					</Button>
				</div>
			</div>
		</div>
	);
};

export default SuccessPage;
